<template>
  <p class="text-base font-light">{{ $t('settings.modulesDesc') }}</p>
  <section class="h-full max-w-md">
    <p class="mb-3 text-lg text-gray-900">{{ $t('settings.modules') }}</p>

    <div v-for="module in mwModules" :key="module.id" class="py-4 border-b first-of-type:border-t">
      <BaseToggle
        :name="module.id"
        :label="module.displayName"
        light
        v-model="module.requiresVisits" />
    </div>

    <BaseButton outline class="w-48 mt-8 text-white border-0 bg-theme-600" @click="onSave">{{
      $t('common.actions.save')
    }}</BaseButton>
  </section>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useToastStore } from '@/stores/toast';
import { useLookupsStore } from '@/stores/lookups';
import { UpdateMWModuleCollection } from '@/services/api/mw';
import { useI18n } from 'vue-i18n';
import { deepCopy } from '@/utils/data';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseToggle from '@/components/common/BaseToggle.vue';
import { ref, watch } from 'vue';
import type { MWModule } from '@/types/MW';

const toastStore = useToastStore();
const { t: $t } = useI18n({ useScope: 'global' });

const { mwModules } = storeToRefs(useLookupsStore());
const originalMWModules = ref<MWModule[]>(deepCopy<MWModule[]>(mwModules.value));
const modifiedModules = ref<MWModule[]>([]);
watch(
  () => mwModules.value,
  () => {
    if (!originalMWModules.value.length) return;
    mwModules.value.forEach((modifiedModule, index) => {
      const originalModule = originalMWModules.value[index];
      if (modifiedModule.requiresVisits !== originalModule.requiresVisits) {
        const existingModuleIdx = modifiedModules.value.findIndex(
          (module) => module.id == modifiedModule.id
        );
        if (existingModuleIdx === -1) modifiedModules.value.push(modifiedModule);
        else modifiedModules.value[existingModuleIdx] = modifiedModule;
      }
    });
  },
  { deep: true }
);

async function onSave() {
  const res = await UpdateMWModuleCollection(modifiedModules.value);
  if (res) toastStore.success({ text: `${$t('common.toast.success')}` });
  else toastStore.error({ text: `${$t('common.toast.error')}` });
}
</script>
